/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newpatient_Continueform2Inputs */

const en_newpatient_continueform2 = /** @type {(inputs: Newpatient_Continueform2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue form`)
};

const fr_newpatient_continueform2 = /** @type {(inputs: Newpatient_Continueform2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuer le formulaire`)
};

/**
* | output |
* | --- |
* | "Continue form" |
*
* @param {Newpatient_Continueform2Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const newpatient_continueform2 = /** @type {((inputs?: Newpatient_Continueform2Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newpatient_Continueform2Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_newpatient_continueform2(inputs)
	return fr_newpatient_continueform2(inputs)
});
export { newpatient_continueform2 as "newPatient_continueForm" }